import store from '@state/store'
import { format, startOfToday, startOfTomorrow, addDays } from 'date-fns'

function formatDate(date) {
  return format(date, 'YYYY-MM-DD')
}

export default (routeTo, routeFrom, next) => {
  /* eslint-disable camelcase */
  const { check_in, check_out, promo_code } = routeTo.query
  const { permalink } = routeTo.params
  const today = formatDate(startOfToday())
  const query = {
    check_in: check_in || today,
    check_out: check_out || formatDate(startOfTomorrow()),
    promo_code: promo_code || '',
  }
  let shouldReload = false

  if (query.check_in < today) {
    query.check_in = today
    shouldReload = true
  }

  if (query.check_out <= query.check_in) {
    query.check_out = formatDate(addDays(query.check_in, 1))
    shouldReload = true
  }
  /* eslint-enable */

  store.commit('cart/SET_QUERY', query)

  if (routeFrom.name === 'booking-confirmation') {
    store.dispatch('clearAllCart')
  }

  if (shouldReload) {
    next({
      name: 'property-landing',
      params: { permalink },
      query,
    })
  } else {
    store
      .dispatch('property/fetchProperty', {
        property: permalink,
      })
      .then((property) => {
        routeTo.params.property = property
        routeTo.params.layoutComponents = ['navbar', 'heroImg', 'searchbar']

        next()
      })
      .catch(() => {
        next({ name: '404', params: { resource: 'Property' } })
      })
  }
}
